(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days && days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function moveToBody(el) {
    if (!el || !document.body) return el;
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function initPopup(root) {
    if (!root || root.getAttribute('data-amc-bound') === '1') return;
    root.setAttribute('data-amc-bound', '1');

    var enabled = root.getAttribute('data-enabled') === 'true';
    var testMode = root.getAttribute('data-test-mode') === 'true';
    var days = parseInt(root.getAttribute('data-delay-days') || '2', 10);
    var cookieName = 'amc-hw-envelope-popup-' + (root.getAttribute('data-section-id') || 'default');
    var teaser =
      document.querySelector('[data-amc-hw-envelope-teaser]') ||
      (root.parentElement && root.parentElement.querySelector('[data-amc-hw-envelope-teaser]'));
    var video = root.querySelector('[data-amc-hw-envelope-popup-video]');
    var envelope = root.querySelector('.amc-hw-envelope-popup__envelope');

    if (!enabled && !testMode) return;
    if (window.location.pathname === '/challenge' || window.location.pathname === '/password') return;

    moveToBody(root);
    if (teaser) teaser = moveToBody(teaser);

    var scrollLocked = false;
    var pageRoot = document.getElementById('PageContainer') || document.querySelector('.page-container');

    function clearLegacyLockStyles() {
      if (pageRoot) {
        pageRoot.style.position = '';
        pageRoot.style.top = '';
        pageRoot.style.left = '';
        pageRoot.style.right = '';
        pageRoot.style.width = '';
      }
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
    }

    /* Wipe leftover fixed-lock from older builds (causes jump). */
    clearLegacyLockStyles();

    function onTouchMove(e) {
      if (!scrollLocked) return;
      if (!e || !e.target) return;
      /* Allow scrolling inside the dialog only */
      if (root.contains(e.target) && e.target.closest('.amc-hw-envelope-popup__dialog')) return;
      e.preventDefault();
    }

    function lockScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      clearLegacyLockStyles();
      document.documentElement.classList.add('amc-hw-envelope-popup-open');
      document.addEventListener('touchmove', onTouchMove, { passive: false });
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      scrollLocked = false;
      document.documentElement.classList.remove('amc-hw-envelope-popup-open');
      document.removeEventListener('touchmove', onTouchMove, { passive: false });
      clearLegacyLockStyles();
      /* Do NOT scrollTo — scroll position was never changed. */
    }

    function playClip(el, on) {
      if (!el) return;
      try {
        el.muted = true;
        el.defaultMuted = true;
        el.playsInline = true;
        el.setAttribute('playsinline', '');
        el.setAttribute('muted', '');
        if (!on) {
          el.pause();
          return;
        }
        var playPromise = el.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } catch (e) {}
    }

    function showTeaser(on) {
      if (!teaser) return;
      if (on) {
        teaser.hidden = false;
        teaser.classList.add('is-visible');
        document.documentElement.classList.add('amc-hw-envelope-teaser-on');
      } else {
        teaser.hidden = true;
        teaser.classList.remove('is-visible');
        document.documentElement.classList.remove('amc-hw-envelope-teaser-on');
      }
    }

    function syncVideoSource() {
      if (!video) return;
      var src = video.getAttribute('data-src');
      if (!src || video.getAttribute('src') === src) return;
      video.setAttribute('src', src);
      try {
        video.load();
      } catch (e) {}
    }

    function playVideo() {
      if (!video) return;
      syncVideoSource();
      playClip(video, true);
    }

    function resetVideo() {
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    function open() {
      showTeaser(false);
      root.hidden = false;
      root.removeAttribute('hidden');
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
      playVideo();
    }

    function close(persist) {
      root.classList.remove('is-open');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      unlockScroll();
      resetVideo();
      if (persist !== false && days > 0) {
        setCookie(cookieName, '1', days);
      }
      /* Always return to teaser — popup never auto-opens */
      if (persist !== false) showTeaser(true);
    }

    root.querySelectorAll('[data-amc-hw-envelope-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    var cta = root.querySelector('[data-amc-hw-envelope-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        if (days > 0) setCookie(cookieName, '1', days);
      });
    }

    if (teaser && teaser.getAttribute('data-amc-teaser-bound') !== '1') {
      teaser.setAttribute('data-amc-teaser-bound', '1');
      teaser.addEventListener('click', function () {
        open();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close(true);
    });

    window.addEventListener(
      'resize',
      function () {
        if (!root.classList.contains('is-open')) return;
        playVideo();
      },
      { passive: true }
    );

    syncVideoSource();

    /* Teaser-first: no auto-open. Modal only via teaser click. */
    showTeaser(true);

    document.addEventListener(
      'shopify:section:unload',
      function () {
        close(false);
      },
      { once: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-amc-hw-envelope-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var node =
      e.target.querySelector('[data-amc-hw-envelope-popup]') ||
      (e.target.matches && e.target.matches('[data-amc-hw-envelope-popup]') ? e.target : null);
    if (node) initPopup(node);
  });
})();
